import React from 'react';
import { Box, Typography } from '@mui/material';
import { color, radius, shadow } from '../../theme/tokens';

// Surface container used for tables, forms, charts and grouped content.
const Panel = ({ title, subtitle, actions, children, sx, bodySx, noPadding = false, dense = false }) => {
  const hasHeader = Boolean(title || subtitle || actions);

  return (
    <Box
      sx={{
        bgcolor: color.surface,
        border: `1px solid ${color.border}`,
        borderRadius: `${radius.xl}px`,
        boxShadow: shadow.xs,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {hasHeader && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            px: dense ? 2 : 2.5,
            py: dense ? 1.5 : 2,
            borderBottom: `1px solid ${color.divider}`,
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            {title && (
              <Typography sx={{ fontSize: '0.9375rem', fontWeight: 600, color: color.ink[900] }}>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography sx={{ mt: 0.25, fontSize: '0.8125rem', color: color.ink[500] }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>{actions}</Box>}
        </Box>
      )}

      <Box sx={{ p: noPadding ? 0 : (dense ? 2 : 2.5), ...bodySx }}>{children}</Box>
    </Box>
  );
};

export default Panel;
